import { Link } from 'react-router-dom'
import { Input, Button } from '../shared/components/ui'

export function CreateAccountPage() {
  function submit() {
    console.log('TODO: trigger create account')
  }

  return (
    <div className="mt-3">
      <div className="w-full max-w-xs mx-auto">
        <form>
          <div className="mb-3">
            <label className="block text-gray-700 text-sm font-bold mb-2">First Name</label>
            <Input id="firstname" type="text" placeholder="First Name" className="w-full" />
          </div>
          <div className="mb-3">
            <label className="block text-gray-700 text-sm font-bold mb-2">Last Name</label>
            <Input id="lastname" type="text" placeholder="Last Name" className="w-full" />
          </div>
          <div className="mb-3">
            <label className="block text-gray-700 text-sm font-bold mb-2">Mobile Number</label>
            <Input id="mobile-number" type="text" placeholder="Mobile Number" className="w-full" />
          </div>
          <div className="mb-3">
            <label className="block text-gray-700 text-sm font-bold mb-2">Email</label>
            <Input id="email" type="text" placeholder="Email" className="w-full" />
          </div>
          <div className="mb-3">
            <label className="block text-gray-700 text-sm font-bold mb-2">Password</label>
            <Input id="password" type="password" placeholder="******************" className="w-full" />
          </div>
          <div className="mb-3">
            <label className="block text-gray-700 text-sm font-bold mb-2">Confirm Password</label>
            <Input
              id="confirm-password"
              type="password"
              placeholder="******************"
              className="w-full"
            />
          </div>
          <div className="flex items-center justify-between">
            <Button type="button" onClick={submit} variant="primary">
              Submit
            </Button>
          </div>
          <div className="flex items-center justify-between mt-4">
            <div className="flex-row">
              Already have account?{' '}
              <Link className="inline-block align-baseline font-bold text-blue-500 hover:text-blue-800 no-underline" to="/login">
                Sign In
              </Link>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}
